import React from "react";
import { Link } from "react-router-dom";

const Home = () => {
  return (
    <div style={styles.container}>
      <h1 style={styles.title}>VahanAPI</h1>
      <p style={styles.subtitle}>Welcome to VahanAPI Portal</p>

      <div style={styles.btnBox}>
        <Link to="/login" style={styles.btn}>
          Login
        </Link>

        <Link to="/register" style={styles.btnOutline}>
          Register
        </Link>
      </div>
    </div>
  );
};

const styles = {
  container: {
    height: "100vh",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    background: "#f5f5f5",
  },
  title: {
    fontSize: "38px",
    fontWeight: "bold",
  },
  subtitle: {
    marginBottom: "30px",
    color: "#555",
  },
  btnBox: {
    display: "flex",
    gap: "20px",
  },
  btn: {
    padding: "12px 30px",
    background: "#000",
    color: "#fff",
    textDecoration: "none",
    borderRadius: "6px",
    fontSize: "16px",
  },
  btnOutline: {
    padding: "12px 30px",
    border: "2px solid #000",
    color: "#000",
    textDecoration: "none",
    borderRadius: "6px",
    fontSize: "16px",
  },
};

export default Home;
